import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=476351d4&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=ts"
export * from "./FilterBox.vue?vue&type=script&lang=ts"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=476351d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476351d4",
  null
  
)

export default component.exports